.root {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 44px 16px;
  text-align: center;
}

/*
 * Цветная иконка на заливке своего тона. Правило 2 (цветной ТЕКСТ на своей заливке → `--ink`)
 * сюда не относится: внутри кружка `<Icon>`, он `aria-hidden`, и `.title` с `.description` под
 * ним говорят то же самое. Пара внесена в `tools/contrast.mjs` видом «декор».
 */
.icon {
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  margin-bottom: 12px;
  border-radius: 50%;
  background: color-mix(in oklch, var(--tint) 14%, var(--tint-on));
  color: var(--tint);
}

.title {
  font-size: 13.5px;
  font-weight: 600;
  color: var(--ink);
}

.description {
  margin-top: 4px;
  font-size: 12.5px;
  color: var(--ink-3);
}
